import { render, staticRenderFns } from "./DownloadCard.vue?vue&type=template&id=15aeef2f"
import script from "./DownloadCard.vue?vue&type=script&lang=js"
export * from "./DownloadCard.vue?vue&type=script&lang=js"
import style0 from "./DownloadCard.vue?vue&type=style&index=0&id=15aeef2f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports